/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Games_YetInputs */

const th_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีเกมในตาราง`)
};

const en_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games scheduled yet.`)
};

const ja_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定されている試合はまだありません。`)
};

const zh_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比赛。`)
};

const es_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay partidos programados.`)
};

const pt_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo agendado ainda.`)
};

const id_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pertandingan yang dijadwalkan.`)
};

const fr_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match programmé pour l’instant.`)
};

const tl_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang nakaiskedyul na laro.`)
};

const vi_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xếp trận nào.`)
};

const ko_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 편성된 경기가 없습니다.`)
};

const de_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spiele angesetzt.`)
};

const ru_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи ещё не назначены.`)
};

const tr_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz maç planlanmadı.`)
};

const it_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita ancora in calendario.`)
};

const pl_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zaplanowano jeszcze meczów.`)
};

const uk_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчів ще не заплановано.`)
};

const hi_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई मैच निर्धारित नहीं है।`)
};

const ar_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُجدوَل أي مباراة بعد.`)
};

const ms_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada perlawanan dijadualkan.`)
};

const bn_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও খেলা নির্ধারিত হয়নি।`)
};

const zh_tw2_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const zh_hk2_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未安排比賽。`)
};

const ur_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی میچ طے نہیں ہوا۔`)
};

const fa_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز بازی‌ای برنامه‌ریزی نشده.`)
};

const sw_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo uliopangwa bado.`)
};

const nl_no_games_yet = /** @type {(inputs: No_Games_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen wedstrijden ingepland.`)
};

/**
* | output |
* | --- |
* | "No games scheduled yet." |
*
* @param {No_Games_YetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_games_yet = /** @type {((inputs?: No_Games_YetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Games_YetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_games_yet(inputs)
	if (locale === "ja") return ja_no_games_yet(inputs)
	if (locale === "zh") return zh_no_games_yet(inputs)
	if (locale === "es") return es_no_games_yet(inputs)
	if (locale === "pt") return pt_no_games_yet(inputs)
	if (locale === "id") return id_no_games_yet(inputs)
	if (locale === "fr") return fr_no_games_yet(inputs)
	if (locale === "tl") return tl_no_games_yet(inputs)
	if (locale === "vi") return vi_no_games_yet(inputs)
	if (locale === "ko") return ko_no_games_yet(inputs)
	if (locale === "de") return de_no_games_yet(inputs)
	if (locale === "ru") return ru_no_games_yet(inputs)
	if (locale === "tr") return tr_no_games_yet(inputs)
	if (locale === "it") return it_no_games_yet(inputs)
	if (locale === "pl") return pl_no_games_yet(inputs)
	if (locale === "uk") return uk_no_games_yet(inputs)
	if (locale === "hi") return hi_no_games_yet(inputs)
	if (locale === "ar") return ar_no_games_yet(inputs)
	if (locale === "ms") return ms_no_games_yet(inputs)
	if (locale === "bn") return bn_no_games_yet(inputs)
	if (locale === "zh-TW") return zh_tw2_no_games_yet(inputs)
	if (locale === "zh-HK") return zh_hk2_no_games_yet(inputs)
	if (locale === "ur") return ur_no_games_yet(inputs)
	if (locale === "fa") return fa_no_games_yet(inputs)
	if (locale === "sw") return sw_no_games_yet(inputs)
	if (locale === "nl") return nl_no_games_yet(inputs)
	return en_no_games_yet(inputs)
});